/*global AmCharts, App */

Components.Energy.Manager.EfficiencyOfWorkBarChart = function(container, loadDataLink, workingZones, tableContainer) {
    /* private */
    var _chart;
    var _workingZonesGuides = [];
    var _periodValue = "Average";
    var zoomOut = function() {
        try {
            _chart.zoomOut();
        } catch (e) {
        }
    };
    var prepareDataForChart = function(rawData) {
        var chartData = [];
        for (var index in rawData) {
            var row = rawData[index];
            var record = {};
            if (row.supplementWorkingTime) {
                record.supplementWorkingTime = Math.round(row.supplementWorkingTime * 100) / 100;
            }
            if (row.efficiencyWorkingTime) {
                record.efficiencyWorkingTime = Math.round(row.efficiencyWorkingTime * 100) / 100;
            }
            if (row.supplementRestTime) {
                record.supplementRestTime = Math.round(row.supplementRestTime * 100) / 100;
            }
            if (row.efficiencyRestTime) {
                record.efficiencyRestTime = Math.round(row.efficiencyRestTime * 100) / 100;
            }
            if (row.efficiency) {
                record.efficiency = Math.round(row.efficiency * 100) / 10000;
            }
            record.date = new Date(row.timestamp * 1000);

            chartData.push(record);
        }

        if (chartData.length == 0) {
            _chart.clear();
        } else {
            _chart.dataSets[0].dataProvider = chartData;
            _chart.validateData();
        }

        try {
            _workingZonesGuides = JSON.parse(workingZones);
        } catch (err) {
            _workingZonesGuides = [];
        }

        createGuides();
    };
    var setDataToTable = function (tableData) {
        for(var index in tableData) {
            var value = tableData[index].value;
            var unit = tableData[index].unit;
            $("#"+ tableContainer + "-" + index + " td:nth-child(2)").text(value);
            $("#"+ tableContainer + "-" + index + " td:nth-child(3)").text(unit);

        }
        $("#"+ tableContainer + "-gaugeChart")[0].value = tableData["averageOfEfficiency"].value;
        $("#"+ tableContainer + "-gaugeChart")[0].ready();
    }
    var loadData = function() {
        App.Ui.widgetBlock($(_chart.containerDiv));
        $.ajax({
            dataType: "json",
            url: loadDataLink,
            complete: function() {
                App.Ui.widgetBlock($(_chart.containerDiv), "stop");
            },
            success: function(result) {
                if (result === null || result.length === 0) {
                    App.Ui.flashMessage(App.Ui.messages.unavailableData, "info");
                } else {
                    if (result.typeOfInterval) {
                        if (result.typeOfInterval === "1-hour") {
                            _chart.categoryAxesSettings.minPeriod = "hh";
                        } else if (result.typeOfInterval === "15-min") {
                            _chart.categoryAxesSettings.minPeriod = "15mm";
                        } else {
                            _chart.categoryAxesSettings.minPeriod = "5mm";
                        }
                    }
                    prepareDataForChart(result.records);
                    if (tableContainer && result.tableData) {
                        setDataToTable(result.tableData);
                    }
                }
            },
            error: function() {
                App.Ui.flashMessage(App.Ui.messages.unavailableData, "info");
            }
        });
    };

    var createChart = function () {
        _chart = new AmCharts.AmStockChart();
        _chart.theme = "light";
        _chart.pathToImages = "/dist/amcharts/images/";
        _chart.dataSets = [
            {
                categoryField: "date",
                fieldMappings: [
                    {
                        fromField: "supplementWorkingTime",
                        toField: "supplementWorkingTime"
                    },
                    {
                        fromField: "efficiencyWorkingTime",
                        toField: "efficiencyWorkingTime"
                    },
                    {
                        fromField: "supplementRestTime",
                        toField: "supplementRestTime"
                    },
                    {
                        fromField: "efficiencyRestTime",
                        toField: "efficiencyRestTime"
                    },
                    {
                        fromField: "efficiency",
                        toField: "efficiency"
                    }
                ]
            }
        ];

        var stockPanel = new AmCharts.StockPanel();
        stockPanel.autoMarginOffset = 50;
        stockPanel.recalculateToPercents = "never";
        stockPanel.usePrefixes = true;
        stockPanel.addListener("dataUpdated", checkDataAfterDataUpdate);


        var workingTimeMainGraph = createColumnGraph("workingTimeMainGraph","efficiencyWorkingTime","#ff1720", "#aed685");
        workingTimeMainGraph.showBalloon = true;
        workingTimeMainGraph.labelText = "[[value]]%";
        workingTimeMainGraph.fontSize = 10;
        workingTimeMainGraph.labelFunction = function (dataItem) {
            if (isDateInWorkingZone(dataItem.dataContext.date)) {
                return Math.round(dataItem.values.value + 100) + "%";
            } else {
                return "";
            }
        };
        workingTimeMainGraph.balloonFunction = function(dataItem) {
            if (isDateInWorkingZone(dataItem.dataContext.date)) {
                return "Normo hodina výkonu: " + Math.round(dataItem.values.value + 100) + "%";
            } else {
                return "";
            }
        };

        var workingTimeSupplementGraph = createColumnGraph("workingTimeSupplementGraph","supplementWorkingTime","#1b99cc", "#1b99cc");
        workingTimeSupplementGraph.useDataSetColors = true;
        workingTimeSupplementGraph.colorField = "color";



        var restTimeMainGraph = createColumnGraph("restTimeMainGraph","efficiencyRestTime","#ff1720", "#d8ebc4");
        restTimeMainGraph.showBalloon = true;
        restTimeMainGraph.labelText = "[[value]]%";
        restTimeMainGraph.fontSize = 10;
        restTimeMainGraph.labelFunction = function (dataItem) {
            if (!isDateInWorkingZone(dataItem.dataContext.date)) {
                return Math.round(dataItem.values.value + 100) + "%";
            } else {
                return "";
            }
        };
        restTimeMainGraph.balloonFunction = function(dataItem) {
            if (!isDateInWorkingZone(dataItem.dataContext.date)) {
                return "Normo hodina výkonu: " + Math.round(dataItem.values.value + 100) + "%";
            } else {
                return "";
            }
        };

        var restTimeSupplementGraph = createColumnGraph("restTimeSupplementGraph","supplementRestTime","#90CDE6", "#90CDE6");


        var scrollGraph = createColumnGraph("scrollGraph","efficiency","#000000", "#000000");
        scrollGraph.fillAlphas = 0;
        scrollGraph.lineAlpha = 0;


        // valueAxesSettings
        var valueAxes = new AmCharts.ValueAxis(workingTimeMainGraph);
        valueAxes.minimum = -100;
        valueAxes.strictMinMax = true;
        valueAxes.labelFunction = function(value) {
            return Math.round(value + 100) + "%";
        };

        valueAxes.guides = [
            {
                lineAlpha: 1,
                lineColor: "#150C63",
                lineThickness: 3,
                label: "NORMO HODINA",
                position: "right",
                above: true,
                value: 0
            }
        ];

        stockPanel.addStockGraph(workingTimeSupplementGraph);
        stockPanel.addStockGraph(workingTimeMainGraph);
        stockPanel.addStockGraph(restTimeSupplementGraph);
        stockPanel.addStockGraph(restTimeMainGraph);
        stockPanel.addStockGraph(scrollGraph);
        stockPanel.addValueAxis(valueAxes);
        _chart.panels.push(stockPanel);

        // panelsSettings
        var panelsSettings = new AmCharts.PanelsSettings();
        panelsSettings.marginLeft = 80;
        _chart.panelsSettings = panelsSettings;

        // scrollbarSettings
        _chart.chartScrollbarSettings = new AmCharts.ChartScrollbarSettings();
        _chart.chartScrollbarSettings.graph = "scrollGraph";
        _chart.chartScrollbarSettings.graphType = "column";
        _chart.chartScrollbarSettings.updateOnReleaseOnly = false;

        // cursorSettings
        _chart.chartCursorSettings = new AmCharts.ChartCursorSettings();
        _chart.chartCursorSettings.categoryBalloonEnabled = true;
        _chart.chartCursorSettings.categoryBalloonDateFormats = [
            {
                period: 'fff',
                format: 'JJ:NN:SS'
            },
            {
                period: 'ss',
                format: 'JJ:NN:SS'
            },
            {
                period: 'mm',
                format: 'JJ:NN DD.MM.YYYY'
            },
            {
                period: 'hh',
                format: 'JJ:NN DD.MM.YYYY'
            },
            {
                period: 'DD',
                format: 'JJ:NN DD.MM.YYYY'
            },
            {
                period: 'WW',
                format: 'DD.MM.YYYY'
            },
            {
                period: 'MM',
                format: 'DD.MM.YYYY'
            },
            {
                period: 'YYYY',
                format: 'MMMM YYYY'
            }
        ];
        _chart.chartCursorSettings.cursorAlpha = 0.05;
        _chart.chartCursorSettings.fullWidth = true;
        _chart.chartCursorSettings.valueBalloonsEnabled = true;
        _chart.chartCursorSettings.valueLineEnabled = true;
        _chart.chartCursorSettings.valueLineBalloonEnabled = true;
        _chart.chartCursorSettings.valueLineAlpha = 0.5;

        // categoryAxesSettings
        _chart.categoryAxesSettings = new AmCharts.CategoryAxesSettings();
        _chart.categoryAxesSettings.groupToPeriods = ["5mm", "15mm", "30mm", "hh", "3hh", "6hh", "12hh", "DD"];
        _chart.categoryAxesSettings.maxSeries = 60;
        _chart.categoryAxesSettings.minPeriod = "5mm";
        _chart.categoryAxesSettings.dateFormats = [
            {
                period: 'fff',
                format: 'JJ:NN:SS'
            },
            {
                period: 'ss',
                format: 'JJ:NN:SS'
            },
            {
                period: 'mm',
                format: 'JJ:NN'
            },
            {
                period: 'hh',
                format: 'JJ:NN'
            },
            {
                period: 'DD',
                format: 'DD.MM.'
            },
            {
                period: 'WW',
                format: 'DD.MM.'
            },
            {
                period: 'MM',
                format: 'DD.MM.'
            },
            {
                period: 'YYYY',
                format: 'MMMM YYYY'
            }
        ];


        _chart.write(container);
        loadData();
    }

    var createColumnGraph = function(id, valueField, color, negativeColor) {
        var graph = new AmCharts.StockGraph();
        graph.id = id;
        graph.useDataSetColors = false;
        graph.valueField = valueField;
        graph.periodValue = _periodValue ;
        graph.type = "column";
        graph.clustered = false;
        graph.fillAlphas = 1;
        graph.columnWidth = 0.75;
        graph.showBalloon = false;
        graph.fillColor = color;
        graph.lineColor = color;
        graph.legendColor = color;
        graph.negativeFillColors = negativeColor;
        graph.negativeLineColor = negativeColor;
        return graph;
    };

    var createGuides = function () {
        for (let i in _workingZonesGuides) {
            let g = new AmCharts.Guide();
            g.fillColor = "#f0f7fa";
            g.fillAlpha = 1;
            g.lineAlpha = 0;
            g.position = "top";
            g.label = "Pracovní doba";
            Object.assign(g, _workingZonesGuides[i]);
            _chart.panels[0].categoryAxis.addGuide(g);
        }
    };
    var zoomToHour = function() {
        zoomOut();
        var startDate = _chart.startDate;
        var endDate = new Date(startDate.getTime() + 1 * 60 * 60 * 1000);
        _chart.zoom(startDate, endDate);
        inactive();
        $("#" + container + "_zoomToHour").addClass("active");
    };
    var zoomToDay = function() {
        zoomOut();
        var startDate = _chart.startDate;
        var endDate = new Date(startDate.getTime() + 1 * 24 * 60 * 60 * 1000);
        _chart.zoom(startDate, endDate);
        inactive();
        $("#" + container + "_zoomToDay").addClass("active");
    };
    var zoomMax = function() {
        zoomOut();
        inactive();
        $("#" + container + "_zoomMax").addClass("active");
    };
    var inactive = function() {
        $("#" + container + "_zoomToHour").removeClass("active");
        $("#" + container + "_zoomToDay").removeClass("active");
        $("#" + container + "_zoomMax").removeClass("active");
    };
    var isDateInWorkingZone = function (date) {
        for (let i in _workingZonesGuides) {
            let workingZone = _workingZonesGuides[i];
            if (new Date(workingZone.date) <= date && new Date(workingZone.toDate) > date) return true;
        }
        return false;
    };
    var checkDataAfterDataUpdate = function () {
        let isChangedDataSet = false;
        for (let i in _chart.panels[0].dataProvider) {
            let data = _chart.panels[0].dataProvider[i];
            if (data.efficiencyWorkingTimeCount) {
                if (!isDateInWorkingZone(data.date)) {
                    if(data.efficiencyRestTimeCount) {
                        if (data.efficiencyRestTimeHigh < data.efficiencyWorkingTimeHigh) {
                            data.efficiencyRestTimeHigh = data.efficiencyWorkingTimeHigh;
                        };
                        if (data.efficiencyRestTimeLow > data.efficiencyWorkingTimeLow) {
                            data.efficiencyRestTimeLow = data.efficiencyWorkingTimeLow;
                        };
                        data.efficiencyRestTimeSum += data.efficiencyWorkingTimeSum;
                        let average = (data.efficiencyRestTimeAverage * data.efficiencyRestTimeCount) + (data.efficiencyWorkingTimeAverage * data.efficiencyWorkingTimeCount);
                        average = average / (data.efficiencyRestTimeCount + data.efficiencyWorkingTimeCount);
                        data.efficiencyRestTimeAverage = average;
                    }
                    delete data["efficiencyWorkingTimeCount"];
                    delete data["efficiencyWorkingTimeAbsHigh"];
                    delete data["efficiencyWorkingTimeAverage"];
                    delete data["efficiencyWorkingTimeClose"];
                    delete data["efficiencyWorkingTimeHigh"];
                    delete data["efficiencyWorkingTimeLow"];
                    delete data["efficiencyWorkingTimeSum"];
                    isChangedDataSet = true;
                }
            }
        };
        if (isChangedDataSet) {
            _chart.panels[0].validateData();
        };
    }

    /* public */
    /* contructor */
    createChart();
    $("#" + container + "_zoomToHour").click(zoomToHour);
    $("#" + container + "_zoomToDay").click(zoomToDay);
    $("#" + container + "_zoomMax").click(zoomMax);
};
